export default "__VITE_ASSET__Bx78ZNsc__"